import React from 'react';
import { Loadable } from 'shared/hocs/loadable';
import { Loader } from 'shared/ui/loader';


export const NinjaAppLoadable = Loadable({
    loader: (): any => import(/* webpackChunkName: "GoodLuckApp" */ './app').then((res) => res.GoodLuckApp),
    loading: <Loader/>,
});
